export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Object, collection, collections, encodeURIComponent, products, selCnt, selected, suppress_from_price) {
      




































pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (! products) {
pug_html = pug_html + "\u003Cp\u003ELoading products\u003C\u002Fp\u003E";
}
else {
pug_html = pug_html + "\u003Cform\u003E\u003Clabel\u003E\u003Cinput" + (" type=\"checkbox\" name=\"suppress_from_price\""+pug_attr("checked", suppress_from_price, true, true)) + "\u003E\nRemove \"from\" price in displayed product name\u003C\u002Flabel\u003E\u003C\u002Fform\u003E\u003Chr\u003E\u003Clabel\u003EFilter by collection\n\u003C\u002Flabel\u003E\u003Cselect name=\"collection\"\u003E\u003Coption\u003E\u003C\u002Foption\u003E";
// iterate collections
;(function(){
  var $$obj = collections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var c = $$obj[pug_index3];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", c.id, true, true)+pug_attr("selected", (collection && c.id == collection.id), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = c.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var c = $$obj[pug_index3];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", c.id, true, true)+pug_attr("selected", (collection && c.id == collection.id), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = c.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E\u003Cdiv class=\"actions\"\u003E";
var selCnt = Object.keys(selected).length;
pug_html = pug_html + "\u003Chr\u003E\u003Cbutton" + (" class=\"hide-selected\""+pug_attr("disabled", (selCnt == 0), true, true)) + "\u003EHide " + (pug_escape(null == (pug_interp = selCnt) ? "" : pug_interp)) + " selected in shop\u003C\u002Fbutton\u003E\u003Cbutton" + (" class=\"unhide-selected\""+pug_attr("disabled", (selCnt == 0), true, true)) + "\u003EUnhide " + (pug_escape(null == (pug_interp = selCnt) ? "" : pug_interp)) + " selected in shop\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cbutton class=\"add-product\"\u003EAdd new product\u003C\u002Fbutton\u003E\u003Cul class=\"products\"\u003E";
// iterate products
;(function(){
  var $$obj = products;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var product = $$obj[pug_index4];
pug_html = pug_html + "\u003Cli" + (pug_attr("class", pug_classes(["product",{"product-hidden": !product.visible}], [false,true]), false, true)) + "\u003E\u003Cinput" + (" class=\"product-select\""+" type=\"checkbox\""+pug_attr("data-product", product.name, true, true)+pug_attr("checked", selected[product.name], true, true)) + "\u003E\u003Ca" + (" class=\"name\""+pug_attr("href", `#/shop/product/${encodeURIComponent(product.name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (! product.visible) {
pug_html = pug_html + "\n(hidden)";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var product = $$obj[pug_index4];
pug_html = pug_html + "\u003Cli" + (pug_attr("class", pug_classes(["product",{"product-hidden": !product.visible}], [false,true]), false, true)) + "\u003E\u003Cinput" + (" class=\"product-select\""+" type=\"checkbox\""+pug_attr("data-product", product.name, true, true)+pug_attr("checked", selected[product.name], true, true)) + "\u003E\u003Ca" + (" class=\"name\""+pug_attr("href", `#/shop/product/${encodeURIComponent(product.name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (! product.visible) {
pug_html = pug_html + "\n(hidden)";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "Object" in locals_for_with ?
        locals_for_with.Object :
        typeof Object !== 'undefined' ? Object : undefined, "collection" in locals_for_with ?
        locals_for_with.collection :
        typeof collection !== 'undefined' ? collection : undefined, "collections" in locals_for_with ?
        locals_for_with.collections :
        typeof collections !== 'undefined' ? collections : undefined, "encodeURIComponent" in locals_for_with ?
        locals_for_with.encodeURIComponent :
        typeof encodeURIComponent !== 'undefined' ? encodeURIComponent : undefined, "products" in locals_for_with ?
        locals_for_with.products :
        typeof products !== 'undefined' ? products : undefined, "selCnt" in locals_for_with ?
        locals_for_with.selCnt :
        typeof selCnt !== 'undefined' ? selCnt : undefined, "selected" in locals_for_with ?
        locals_for_with.selected :
        typeof selected !== 'undefined' ? selected : undefined, "suppress_from_price" in locals_for_with ?
        locals_for_with.suppress_from_price :
        typeof suppress_from_price !== 'undefined' ? suppress_from_price : undefined));
    ;;return pug_html;}